module.exports = __webpack_public_path__ + "img/1-05.87427939.png";